export default __webpack_public_path__ + "static/media/home-config.78ece296.svg";